/* cache-refresh 2026-07-25T18:30 */
/* PDP Mobil (24.07.2026, Sichtbarkeit 25.07.2026 auf Scroll-Listener umgestellt,
   Preis im Bar-CTA 25.07.2026)
   - Sticky Buy-Bar: spiegelt Beschriftung, Preis und Verfuegbarkeit aus der Buy-Box.
     Seit 25.07.2026 steht der Preis IM Button ("In den Warenkorb · 279 €"),
     links bleibt nur der Produktname. Quelle ist [data-pdp-total] (Preis x Menge),
     ersatzweise [data-pdp-price] - also exakt der Wert, den pdp.js auch fuer den
     Desktop-CTA verwendet.
     Der Bar-Button klickt den echten Warenkorb-Button, damit Pflichtfelder,
     Wende-Konfigurator, Loader und Warenkorb-Drawer unveraendert greifen.
   - Kurzer CTA-Text: fuegt dem Warenkorb-Button ein zweites Label-Span hinzu,
     das per CSS unter 640px anstelle des langen Textes erscheint.
   Greift nicht in pdp.js ein, sondern beobachtet dessen Ausgabe. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-pdp-main]');
    var bar = document.querySelector('[data-pdp-stickybar]');
    if (!root) return;

    var buyBox = root.querySelector('.pdp-buybox') || root;
    var mainBtn = root.querySelector('.pdp-buybox .pdp-atc');
    var buyRow = root.querySelector('.pdp-buy-row');
    if (!mainBtn || !buyRow) return;

    var barBtn = bar ? bar.querySelector('[data-pdp-bar-btn]') : null;
    /* Nur noch Fallback: die Preiszeile links wurde am 25.07.2026 aus der
       Section entfernt, damit der Preis nicht doppelt in der Leiste steht. */
    var barPrice = bar ? bar.querySelector('[data-pdp-bar-price]') : null;

    var ctaDefault = (mainBtn.getAttribute('data-pdp-cta-default') || '').trim();
    var ctaCustom = (mainBtn.getAttribute('data-pdp-cta-custom') || '').trim();
    var ctaShort = ((bar && bar.getAttribute('data-cta-short')) || ctaCustom).trim();

    function currentLabel() {
      var el = mainBtn.querySelector('[data-pdp-cta-label]');
      return el ? el.textContent.trim() : ctaDefault;
    }

    function shortFor(label) {
      if (ctaCustom && label === ctaCustom) return ctaShort;
      return ctaDefault || label;
    }

    /* Preis der aktuellen Auswahl, so wie ihn die Buy-Box anzeigt.
       [data-pdp-total] beruecksichtigt die Menge, [data-pdp-price] ist der
       Einzelpreis. Beide werden von pdp.js formatiert (z. B. "279 €").
       Bewusst bei jedem Aufruf neu gesucht: pdp.js baut Teile der Buy-Box
       nachtraeglich auf, feste Referenzen aus dem Init waeren dann veraltet
       oder gar nicht vorhanden. */
    function currentPrice() {
      var el = buyBox.querySelector('[data-pdp-total]');
      var text = el ? el.textContent.trim() : '';
      if (!text) {
        el = buyBox.querySelector('[data-pdp-price]');
        text = el ? el.textContent.trim() : '';
      }
      return text.replace(/\s+/g, ' ');
    }

    function ensureShortSpan() {
      var longEl = mainBtn.querySelector('[data-pdp-cta-label]');
      if (!longEl) return null;
      if (!longEl.classList.contains('pdp-atc-label--long')) {
        longEl.classList.add('pdp-atc-label--long');
      }
      var shortEl = mainBtn.querySelector('.pdp-atc-label--short');
      if (!shortEl) {
        shortEl = document.createElement('span');
        shortEl.className = 'pdp-atc-label--short';
        longEl.insertAdjacentElement('afterend', shortEl);
      }
      return shortEl;
    }

    /* Der Bar-Button traegt zwei Spans: Beschriftung (kuerzbar) und Preis
       (wird nie abgeschnitten). Fehlt eines, werden beide neu aufgebaut. */
    function barParts() {
      if (!barBtn) return null;
      var labelEl = barBtn.querySelector('[data-pdp-bar-btn-label]');
      var priceEl = barBtn.querySelector('[data-pdp-bar-btn-price]');

      if (!labelEl || !priceEl) {
        var fallback = barBtn.textContent.trim();
        barBtn.textContent = '';

        labelEl = document.createElement('span');
        labelEl.className = 'pdp-stickybar__btn-label';
        labelEl.setAttribute('data-pdp-bar-btn-label', '');
        labelEl.textContent = fallback;
        barBtn.appendChild(labelEl);

        priceEl = document.createElement('span');
        priceEl.className = 'pdp-stickybar__btn-price';
        priceEl.setAttribute('data-pdp-bar-btn-price', '');
        barBtn.appendChild(priceEl);
      }

      return { label: labelEl, price: priceEl };
    }

    var busy = false;
    function sync() {
      if (busy) return;
      busy = true;

      var label = currentLabel();
      var short = shortFor(label);

      var shortEl = ensureShortSpan();
      if (shortEl && shortEl.textContent !== short) shortEl.textContent = short;

      var price = currentPrice();

      if (barPrice && price && barPrice.textContent !== price) {
        barPrice.textContent = price;
      }

      if (barBtn) {
        var parts = barParts();
        if (parts.label.textContent !== short) parts.label.textContent = short;
        if (parts.price.textContent !== price) parts.price.textContent = price;
        if (price) parts.price.removeAttribute('hidden');
        else parts.price.setAttribute('hidden', 'hidden');
        barBtn.disabled = !!mainBtn.disabled;
        barBtn.setAttribute('aria-label', price ? short + ', ' + price : short);
      }

      busy = false;
    }

    sync();

    if ('MutationObserver' in window) {
      var schedule = function () {
        if (window.requestAnimationFrame) window.requestAnimationFrame(sync);
        else sync();
      };
      var mo = new MutationObserver(schedule);
      /* Die gesamte Buy-Box beobachten statt einzelner Knoten: pdp.js ersetzt
         Preis- und Label-Elemente teilweise komplett, einzelne Referenzen
         wuerden dabei ins Leere laufen. */
      mo.observe(buyBox, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'data-button-content']
      });
    }

    /* Variantenwechsel und Mengenaenderung laufen ueber pdp.js; der Preis im
       Button folgt ueber die Observer oben. Der zusaetzliche Event-Listener
       faengt Faelle ab, in denen pdp.js die Preis-Nodes komplett ersetzt. */
    document.addEventListener('variant:changed', function () {
      if (window.requestAnimationFrame) window.requestAnimationFrame(sync);
      else sync();
    });

    if (!bar || !barBtn) return;

    barBtn.addEventListener('click', function () {
      mainBtn.click();
    });

    /* Sichtbarkeit ueber Scroll-Position statt IntersectionObserver:
       der IO-Zustandswechsel konnte beim Laden verpuffen und die Bar blieb
       dauerhaft versteckt. Ein throttled Scroll-/Resize-Listener prueft direkt,
       ob die Kaufzeile nach oben aus dem Bild ist, und kann nicht haengenbleiben.
       Nur bis 999px aktiv (ab 1000px greift die sticky Buy-Box, die Bar ist per
       CSS ausgeblendet). */
    var ticking = false;
    function evaluate() {
      ticking = false;
      var mobile = window.innerWidth <= 999;
      if (!mobile) { bar.classList.remove('is-visible'); return; }
      var rect = buyRow.getBoundingClientRect();
      var pastTop = rect.bottom < 0;
      bar.classList.toggle('is-visible', pastTop);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(evaluate);
      else evaluate();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    evaluate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
